<template>
  <div class="password-edit-page">
    <a-card :bordered="false" class="profile-card">
      <template slot="title">
        <div class="card-title-row">
          <div class="card-title-left">
            <a-button type="link" size="small" @click="$router.back()" style="padding: 0; margin-right: 8px;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </a-button>
            <span class="card-title-text">修改密码</span>
          </div>
        </div>
      </template>

      <a-form-model
        ref="passwordForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="原密码" prop="oldPassword">
          <a-input-password v-model="form.oldPassword" placeholder="请输入原密码" />
        </a-form-model-item>

        <a-form-model-item label="新密码" prop="newPassword">
          <a-input-password v-model="form.newPassword" placeholder="请输入新密码（至少6位）" />
        </a-form-model-item>

        <a-form-model-item label="确认新密码" prop="confirmPassword">
          <a-input-password v-model="form.confirmPassword" placeholder="请再次输入新密码" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ offset: 5, span: 14 }">
          <div class="form-actions">
            <a-button @click="$router.back()">取消</a-button>
            <a-button type="primary" :loading="submitting" @click="handleSubmit">确认修改</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import util from '@/libs/util';

export default {
  name: 'WodePassword',
  data() {
    // 确认密码验证
    const confirmPasswordValidator = (rule, value, callback) => {
      if (value && value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      submitting: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: confirmPasswordValidator, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters('main/user', ['info'])
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.passwordForm.validate();
      } catch {
        return;
      }

      this.submitting = true;
      try {
        const res = await this.$api.change_password({
          userId: this.info?.id,
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword
        });

        if (res && res.success) {
          this.$message.success('密码修改成功，请重新登录');
          // 清除 token 和用户信息，跳转到登录页
          util.cookies.set('token', null);
          localStorage.setItem('aoxy-user', null);
          this.$store.commit('main/user/SET_INFO', null);
          this.$router.replace('/sign-in');
        } else {
          this.$message.error(res?.message || '密码修改失败');
        }
      } catch (err) {
        console.error('[wode-password] submit error:', err);
        this.$message.error('网络异常，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.password-edit-page {
  max-width: 900px;
  margin: 0 auto;
}

.profile-card {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.card-title-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
